import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from '../store/auth'
import { Close } from './Icon'

const NAV: { to: string; label: string; emoji: string }[] = [
  { to: '/compare', label: 'compare', emoji: '⇌' },
  { to: '/correlate', label: 'AI correlate', emoji: '⊜' },
  { to: '/analysis', label: 'analysis', emoji: '🛡' },
  { to: '/bulk', label: 'bulk signup', emoji: '⊕' },
  { to: '/lurker', label: 'lurker', emoji: '⌖' },
]

export function MobileMenu({
  open,
  onClose,
  onOpenSettings,
}: {
  open: boolean
  onClose: () => void
  onOpenSettings: () => void
}) {
  const session = useAuth((s) => s.session)
  const location = useLocation()

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    if (open) document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return (
    <div
      className={`fixed inset-0 z-[60] transition ${open ? 'pointer-events-auto' : 'pointer-events-none'}`}
      aria-hidden={!open}
    >
      <div
        className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      <aside
        className={`absolute right-0 top-0 h-full w-72 max-w-[85%] transform transition-transform ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div
          className="m-3 h-[calc(100%-1.5rem)] rounded-2xl border p-4 shadow-glass backdrop-blur-xl"
          style={{
            background: 'rgba(8, 14, 32, 0.94)',
            borderColor: 'rgba(56, 189, 248, 0.22)',
          }}
        >
          <div className="mb-4 flex items-center justify-between">
            <span className="text-sm font-bold tracking-widest text-ink-200">MENU</span>
            <button
              type="button"
              onClick={onClose}
              className="grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/5 text-ink-100 hover:bg-white/10"
              aria-label="close menu"
            >
              <Close />
            </button>
          </div>
          <nav className="flex flex-col gap-1">
            {NAV.map((n) => {
              const active = location.pathname.startsWith(n.to)
              return (
                <Link
                  key={n.to}
                  to={active ? '/' : n.to}
                  onClick={onClose}
                  className={`flex items-center justify-between rounded-xl border px-3 py-2.5 text-sm transition ${
                    active
                      ? 'border-[color:var(--accent-strong)] bg-white/10 text-white'
                      : 'border-white/10 bg-white/5 text-ink-100 hover:bg-white/10'
                  }`}
                >
                  <span className="flex items-center gap-3">
                    <span className="w-5 text-center">{n.emoji}</span>
                    <span>{n.label}</span>
                  </span>
                  {active ? (
                    <span className="text-[10px] uppercase tracking-widest text-ink-300">on</span>
                  ) : null}
                </Link>
              )
            })}
          </nav>

          <div className="mt-4 border-t border-white/5 pt-4">
            <button
              type="button"
              onClick={() => {
                onClose()
                onOpenSettings()
              }}
              className="flex w-full items-center justify-between rounded-xl border border-white/10 bg-white/5 px-3 py-2.5 text-sm text-ink-100 hover:bg-white/10"
            >
              <span className="flex items-center gap-3">
                <span className="w-5 text-center">⚙</span>
                <span>settings</span>
              </span>
            </button>
          </div>

          {session ? (
            <div className="mt-4 border-t border-white/5 pt-4 text-xs text-ink-300">
              signed in as
              <div className="mt-1 flex items-center gap-2 truncate text-sm font-semibold text-white">
                <span className="h-2 w-2 flex-shrink-0 rounded-full accent-bg" />
                @{session.handle}
              </div>
            </div>
          ) : null}
        </div>
      </aside>
    </div>
  )
}
